import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { FeedActivityFragment } from '@spotify/confidence-graphql';

export interface FeedItemOptions {
  activity: FeedActivityFragment;
}

export const FeedItemExtensions = createItemRenderExtensions({
  id: 'feed-item',
});

export const useFeedItemExtensions = () => {
  return useItemRenderExtensions<ItemRenderExtensionOptions<FeedItemOptions>>(
    FeedItemExtensions,
  );
};

export const createFeedItemExtension = (
  options: ItemRenderExtensionOptions<FeedItemOptions>,
) => {
  return createItemRenderExtension<ItemRenderExtensionOptions<FeedItemOptions>>(
    options,
  );
};
